import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import api, { apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const params = new URLSearchParams(window.location.hash.replace(/^#/, ""));
    const sid = params.get("session_id");
    if (!sid) {
      navigate("/admin/login", { replace: true });
      return;
    }
    (async () => {
      try {
        await api.post("/auth/google/session", {}, { headers: { "X-Session-ID": sid } });
        await refresh();
        navigate("/admin", { replace: true });
      } catch (e) {
        navigate("/admin/login", {
          replace: true,
          state: { error: apiError(e.response?.data?.detail) },
        });
      }
    })();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="min-h-screen grid place-items-center bg-primary text-primary-foreground">
      <Loader2 className="h-6 w-6 animate-spin text-gold" />
    </div>
  );
}
